import React, { Component, Fragment } from "react";
import IntlMessages from "Util/IntlMessages";
import {
    Row,
    Card,
    CardBody
} from "reactstrap";
import ReactSiemaCarousel from "Components/ReactSiema/ReactSiemaCarousel";
import {

    DoughnutShadow
} from "Components/Charts";
import { Colxx } from "Components/CustomBootstrap";
import NumberFormat from 'react-number-format';
import API from '../../../api/index';
import CircularProgressbar from "react-circular-progressbar";
import "chartjs-plugin-datalabels";
import "react-circular-progressbar/dist/styles.css";

import {
    chartTooltip, centerTextPlugin
} from "Components/Charts";

import { ThemeColors } from "Util/ThemeColors";
const colors = ThemeColors();
export default class AnalyticsDashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            DashboardData: false,
            DoughnutChardData: {
                plugins: [centerTextPlugin],
                legend: {
                    position: "bottom",
                    labels: {
                        padding: 30,
                        usePointStyle: true,
                        fontSize: 12,
                        fontFamily: "irsans_l"
                    }
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: false
                    },
                    cutoutPercentage: 70,
                    layout: {
                        padding: {
                            bottom: 20
                        }
                    },
                    fontFamily: "irsans_l",
                    tooltips: chartTooltip
                },
                data: {
                    labels: ["تبدیل شده", "همه سرنخ ها"],
                    datasets: [
                        {
                            label: "",
                            borderColor: [colors.themeColor1, colors.themeColor2],
                            backgroundColor: [colors.themeColor1, colors.themeColor2],
                            fontFamily: "irsans_l",
                            borderWidth: 2,
                            data: [15, 85]
                        }
                    ]
                }
            }
        };

        this.loadData = this.loadData.bind(this);
        this.loadData();
    }

    loadData() {
        API.crm.lead.dashboard()
            .then(data => {
                (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;

                var _DoughnutChardData = this.state.DoughnutChardData;
                var _PercentConverted = Math.round(((data.Dashboard.Count.AllConverteds * 100) / data.Dashboard.Count.AllLeads) * 100) / 100;
                _DoughnutChardData.data.datasets[0].data = [_PercentConverted, 100 - _PercentConverted];
                this.setState({
                    DoughnutChardData: _DoughnutChardData,
                    DashboardData: data.Dashboard,
                    isLoading: false
                });
            })
            .catch(error => { });
    }

    render() {
        return (
            this.state.isLoading ?
                <div className="loading"></div>
                :
                <Fragment>
                    <Row>
                        <Colxx xl="12" >
                            <div className="icon-cards-row">
                                <ReactSiemaCarousel
                                    perPage={{ 4: 4 }}
                                    controls={false}
                                    loop={false}
                                >

                                    <div className="icon-row-item">
                                        <Card className="mb-4 ">
                                            <CardBody className="text-center">
                                                <i className="iconsminds-pulse" />
                                                <p className="card-text font-weight-semibold mb-0">
                                                    همه پالس ها
                                                </p>
                                                <p className="lead text-center">
                                                    {<NumberFormat value={this.state.DashboardData.Count.AllPulses} displayType={'text'} thousandSeparator={true} renderText={(value, prop) => <span >{value}</span>} />}
                                                </p>
                                            </CardBody>
                                        </Card>
                                    </div>


                                    <div className="icon-row-item hasarrow hastlastarrow">
                                        <Card className="mb-4 lastarrow" onClick={(e) => { this.props.history.push("/app/crm/lead/list/converted") }}>
                                            <CardBody className="text-center">
                                                <i className="iconsminds-business-man-woman" />
                                                <p className="card-text font-weight-semibold mb-0">
                                                    سرنخ های تبدیل شده
                                                </p>
                                                <p className="lead text-center">
                                                    {<NumberFormat value={this.state.DashboardData.Count.AllConverteds} displayType={'text'} thousandSeparator={true} renderText={(value, prop) => <span >{value}</span>} />}
                                                </p>
                                            </CardBody>
                                        </Card>
                                    </div>
                                    <div className="icon-row-item hasarrow">
                                        <Card className="mb-4 midarrow" onClick={(e) => { this.props.history.push("/app/crm/lead/list/multi") }} style={{ cursor: "pointer" }}>
                                            <CardBody className="text-center">
                                                <i className="iconsminds-pulse" />
                                                <p className="card-text font-weight-semibold mb-0">
                                                    سرنخ ها با چند پالس
                                                </p>
                                                <p className="lead text-center">
                                                    {<NumberFormat value={this.state.DashboardData.Count.AllMultiPulses} displayType={'text'} thousandSeparator={true} renderText={(value, prop) => <span >{value}</span>} />}
                                                </p>
                                            </CardBody>
                                        </Card>
                                    </div>
                                    <div className="icon-row-item hasarrow">
                                        <Card className="mb-4 firstarrow" onClick={(e) => { this.props.history.push("/app/crm/lead/list/all") }} style={{ cursor: "pointer" }}>
                                            <CardBody className="text-center">
                                                <i className="iconsminds-leaning-tower" />
                                                <p className="card-text font-weight-semibold mb-0">
                                                    همه سرنخ ها
                                                </p>
                                                <p className="lead text-center">
                                                    {<NumberFormat value={this.state.DashboardData.Count.AllLeads} displayType={'text'} thousandSeparator={true} renderText={(value, prop) => <span >{value}</span>} />}</p>
                                            </CardBody>
                                        </Card>
                                    </div>

                                </ReactSiemaCarousel>
                            </div>
                        </Colxx>
                        <Colxx xl={8}>
                            <Card className="timeline-card " style={{ "backgroundColor": "transparent" }}>

                                <CardBody style={{ "backgroundColor": "rgba(0,0,0,0.03)" }}>

                                    <Row>
                                        <Colxx xl="4" className="mb-4">
                                            <Card className="actioncard" onClick={(e) => { this.props.history.push("/app/crm/lead/add") }} style={{ cursor: "pointer" }}>
                                                <CardBody className="d-flex justify-content-between align-items-center">
                                                    <div className="float-left ">
                                                        <br />
                                                        <span style={{ fontWeight: "bold", fontSize: "24px" }}>
                                                            ثبت سرنخ
                                                        </span>
                                                        <br />
                                                        <br />

                                                    </div>
                                                    <div className="progress-bar-circle">
                                                        <i className="simple-icon-plus" style={{ fontSize: "60px" }} />
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </Colxx>
                                        <Colxx xl="4" className="mb-4">
                                            <Card className="actioncard" onClick={(e) => { this.props.history.push("/app/crm/lead/list/pending") }} style={{ cursor: "pointer" }}>
                                                <CardBody className="d-flex justify-content-between align-items-center">
                                                    <div className="float-left ">
                                                        <br />
                                                        <span style={{ fontWeight: "bold", fontSize: "24px" }}>
                                                           ثبت اتوماتیک
                                                        </span>
                                                        <br />
                                                        <br />

                                                    </div>
                                                    <div className="progress-bar-circle" style={{marginLeft:"10px"}}>
                                                        <i className="iconsminds-loading-3" style={{ fontSize: "60px" }} />
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </Colxx>
                                    </Row>
                                    <Row>
                                        {this.state.DashboardData.Pulses.map((pulse, index) => (
                                            <Colxx xl="4" className="mb-4" key={index}>
                                                <Card onClick={(e) => { this.props.history.push("/app/crm/lead/list/tag/" + pulse.ID) }} style={{ cursor: "pointer" }}>
                                                    <CardBody className="d-flex justify-content-between align-items-center">
                                                        <div className="float-left ">
                                                            <span style={{ fontWeight: "bold", fontSize: "16px" }}>{pulse.Name}</span>
                                                            <br />
                                                            <br />
                                                            <span style={{ color: "gray" }}>
                                                                تعداد کل: {pulse.Total}
                                                            </span>
                                                            <br />
                                                            <span style={{ color: "gray" }}>
                                                                تبدیل شده: {pulse.Converted}
                                                            </span>
                                                        </div>
                                                        <div className="progress-bar-circle">
                                                            <CircularProgressbar
                                                                strokeWidth={4}
                                                                percentage={Math.round((pulse.Converted * 100 / pulse.Total) * 100) / 100}
                                                                text={(Math.round((pulse.Converted * 100 / pulse.Total) * 100) / 100) + "%"}
                                                            />
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </Colxx>
                                        ))}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Colxx>
                        <Colxx xl={4}>
                            <Card >

                                <CardBody>
                                    <div className="dashboard-donut-chart">
                                        <DoughnutShadow {...this.state.DoughnutChardData} />
                                    </div>
                                </CardBody>
                            </Card>
                        </Colxx>
                    </Row>
                </Fragment>
        );
    }
}
